export default function Bono( { bono } ) {
	const statusClass =
		bono.status === 'valid'
			? 'sci-bcl-bono__estado sci-bcl-bono__estado--valid'
			: 'sci-bcl-bono__estado sci-bcl-bono__estado--invalid';

	return (
		<div className="sci-bcl-bono">
			<div className="sci-bcl-bono__wrapper">
				<div className="sci-bcl-bono__codigo">
					<p className="sci-bcl-bono__valor">{ bono.value / 100 }€</p>
					<p className="sci-bcl-bono__numero">{ bono.codigo }</p>
				</div>
				<p className={ statusClass }>
					{ 'valid' === bono.status ? 'Válido' : 'Inválido' }
				</p>
				<p className="sci-bcl-bono__usuario">
					{ bono.user.name } - { bono.user.nif }
				</p>
				{ bono.error && (
					<p className="sci-bcl-bono__error">{ bono.error }</p>
				) }
			</div>
		</div>
	);
}
